import { Card, Grid, Chip, Typography, Button, Tooltip, Pagination, PaginationItem } from "@mui/material"

import { BreakfastDiningOutlined } from "@mui/icons-material";
import { Incentive, Incentiveincomequalifiedcategoricaleligibilitycriteria, Incentiveincomequalifiedpercentageeligibilitycriteria } from "./rebate-types";
import { ProductMetadataCoreViewModel, ProductResultsResponse } from "../types";
import { useQuery } from "@tanstack/react-query";
import { RebateResultCard } from "./rebate-result-card";
import { DateTime } from "luxon";
import { Box, Stack } from "@mui/system";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { convertDate, generateDescriptionWithData } from "./Functions_lib.tsx/description_generation";
interface PreviewProps {
    recordsFound: string,
    page: string
    formData: string
    queryParams: string,
    isMobile: boolean,
    basePath: string
}
export interface PublishedIncentiveData {
    incentive_id: number;
    publishedincentiveid: number;
    incentivedata: string;
    created_on: Date;
    created_by: string;
    deleted: string;
    incentive_start_date: Date;
    incentive_end_date: Date;
    product: string;
    product_category: string;
    product_general: string;
    utility: string;
    zipcodes: string;
}
export type ImpProductResultsResponse = {
    language: string;
    product: ProductMetadataCoreViewModel;
    pageSize: number;
    currentPageNumber: number;
    maxPageNumber: number;
    sort: string;
    resultsCount: number;
    results: PublishedIncentiveData[];
}

export const PreviewIncentiveResult = ({ queryParams, isMobile, page, recordsFound, basePath }: PreviewProps) => {
    
    const [queryParamsData, setQueryParamsData] = useState<string>(queryParams);
    const [isTopPaginationEnabled, setIsTopPaginationEnabled] = useState(false);
    const [currentPageNumber, setCurrentPageNumber] = useState(parseInt(page) + 1);
    const [lastPageNumber, setLastPageNumber] = useState<Number>(1)
    if (isMobile) {
        const widgetElement: HTMLElement = document.getElementById('results-div') as HTMLElement;

        const observerOptions = {
            attributes: true,
            childList: false,
            subtree: false,
        };

        const observer = new MutationObserver(attributeChanges);
        observer.observe(widgetElement, observerOptions);

        function attributeChanges(mutations: MutationRecord[], observer: MutationObserver) {
            for (const record of mutations) {
                console.log(record);
            }

            const dataFilteringUrl: string | null = widgetElement.getAttribute("data-filterurl");
            const dataPagingUrl: string | null = widgetElement.getAttribute("data-pagingurl");
            if (dataFilteringUrl) {
                setQueryParamsData("?" + dataFilteringUrl)
                
            }

        }
    }


    //DATA

    const getRebates = useCallback(async () => {
        let res = null;
        const productUniqueName = "imp_rebate_results";
        if (window.location.hostname === "localhost") {
            res = await fetch('http://localhost:8080/productfinder/api/' + productUniqueName + `/data` + queryParamsData);
        } else if(!isMobile && window.location.hostname !== "localhost"){
            res = await fetch(basePath + 'productfinder/api/' + productUniqueName + `/data` + queryParamsData);
        }else{
            res = await fetch(basePath + 'api/' + productUniqueName + `/data` + queryParamsData);
        }

        console.log(res.url);
        //console.log(res.json());
        return await res.json() as Promise<ImpProductResultsResponse>;
    }, [queryParamsData]);

    const { isSuccess, data } = useQuery([queryParamsData], getRebates);



    //helpers and customization    
    

    const CustomizedArrowBack = () => {
        return <ArrowBackIcon sx={{ fontSize: '1.9em' }} />
    }

    const CustomizedArrowForward = () => {
        return <ArrowForwardIcon sx={{ fontSize: '1.9em' }} />
    }

    //pagination
    function handlePageChange(event: any, page: number): void {
        const pageNumber: HTMLElement = document.getElementById('page_number') as HTMLElement;
        pageNumber.setAttribute("value", `${page -1}`)
        const zipCode  = (document.getElementById("zip_code_filter") as HTMLElement).getAttribute("value")
        const form = document.getElementById('results_form_base') as HTMLFormElement;
        const serialized = new URLSearchParams((new FormData(form)) as any).toString();
        console.log(serialized);



        setCurrentPageNumber(page)
        //window.location.search.replace(pageNum, "?" +updatedQueryParams)
        setQueryParamsData("?" + serialized )

        window.history.pushState(null, "", "?" + serialized)

    }
    const getNextPageString = (bool: boolean, page: Number) => {
        if (bool) {
            return ("page_number=" + page + "&")
        }
        else {
            return ("page_number=" + page)
        }
    }
    const displayPagination = (data: ImpProductResultsResponse) => {

        return (<Stack spacing={2} sx={{ padding: 4, marginLeft: '15%' }}>
            <Pagination
                count={Math.ceil(data.resultsCount / 20)}
                page={currentPageNumber}
                siblingCount={0}
                boundaryCount={0}
                onChange={handlePageChange}
                sx={{ width: '100%' }}
                renderItem={(item) => (
                    <PaginationItem
                        sx={{ fontSize: "1.7em" }}
                        slots={{ previous: CustomizedArrowBack, next: CustomizedArrowForward }}
                        {...item}

                    />
                )}
            />
        </Stack>)
    }




    const renderRebates = () => {
        const elementArray: JSX.Element[] = []
        if (data && data.resultsCount > 0 && parseInt(recordsFound) !== 0) {
            let previousUtility = ""
            for (const result of data.results) {
                const parsedIncentive = JSON.parse(result.incentivedata) as Incentive
                const startDateFormatted = convertDate(Number(parsedIncentive?.incentivestartedate))
                const endDateFormatted = parsedIncentive?.incentiveenddate !== null && parsedIncentive?.incentiveenddate !== undefined ? convertDate(Number(parsedIncentive?.incentiveenddate)) : "no current end date"
                console.log(parsedIncentive)

             if(parsedIncentive !== null){
                elementArray.push(
                    <Box sx={{ padding: 1 }}>
                        {isMobile && result === data.results[0] && data.resultsCount > 20 ? displayPagination(data) : null}
                        {result.utility !== previousUtility ?
                            <Box sx={{ display: "flex", flexDirection: "row", paddingBottom: .25 }}><Typography sx={{ fontSize: '10px !important' }}>Incentives offered by: </Typography><Typography sx={{ fontSize: '18px !important', fontWeight: 'bold !important', marginTop: { md: -.70, xs: -1 },paddingLeft: .5, color: "#0e4d82" }}>{result.utility}</Typography></Box> : null
                        }

                        <RebateResultCard
                            product={result.product_general}
                            incentiveAmount={parsedIncentive.incentiveamount ?? ""}
                            partnerName={parsedIncentive.workspace?.incentiveorganization?.incentiveorganizationname ?? ""}
                            customerHotline={parsedIncentive.customerhotline ?? ""}
                            programWebAddress={parsedIncentive.programwebaddress ?? ""}
                            startDate={startDateFormatted}
                            endDate={endDateFormatted}
                            incentiveType={parsedIncentive.incentivetype?.incentivetypename ?? ""}
                            description={generateDescriptionWithData(parsedIncentive, result.product_general, startDateFormatted, endDateFormatted, result.product)}
                            productDetail={result.product}
                            isIncomeQualified={false}
                        />

                        {isMobile && result === data.results[data.results.length - 1] && data.resultsCount > 20 ? displayPagination(data) : null}


                    </Box>)
                       }
                previousUtility = result.utility
                    
            }
            return elementArray
        } else {
            return null
        }

    }




    return (

        <>
            {renderRebates()}
        </>

    )


}


